<div class="title">
  <div class="container container-max-width">
    <div>
      <h4>Create Ad Hoc Request</h4>
      <p>Submit a PF capacity request with one or more subrequests</p>
    </div>
  </div>
</div>

<div class="container container-content container-max-width">
  <div class="landing-main mt-3">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <fieldset class="fieldsetstyle mb-4">
        <h5>
          Request Information
          <i
            class="fa fa-info-circle"
            [ngbTooltip]="requestInformationTooltip"
            placement="top"
            container="body"
            tabindex="0"
            [attr.aria-label]="requestInformationTooltip"
          ></i>
        </h5>
        <hr />

        <div class="form-group row mb-3">
          <label for="manatree" class="col-sm-3 col-form-label request-label">
            Manatree:
            <i
              class="fa fa-info-circle"
              [ngbTooltip]="manatreeTooltip"
              placement="top"
              container="body"
              tabindex="0"
              [attr.aria-label]="manatreeTooltip"
            ></i>
          </label>
          <div class="col-sm-9">
            <ng-select
              class="request-input"
              id="manatree"
              formControlName="manatree"
              [items]="manatreeOptions"
              placeholder="Select Manatree"
              [virtualScroll]="true"
              [clearable]="false"
              notFoundText="No Manatrees are available"
              (change)="onManatreeChanged()"
            >
            </ng-select>
            <small
              class="text-danger"
              *ngIf="form.get('manatree')?.hasError('required') && form.get('manatree')?.touched"
            >
              Manatree is required
            </small>
          </div>
        </div>

        <div class="form-group row mb-3">
          <label for="serviceTreeId" class="col-sm-3 col-form-label request-label">
            Service Tree ID:
            <i
              class="fa fa-info-circle"
              [ngbTooltip]="serviceTreeTooltip"
              placement="top"
              container="body"
              tabindex="0"
              [attr.aria-label]="serviceTreeTooltip"
            ></i>
          </label>
          <div class="col-sm-9">
            <ng-select
              class="request-input service-tree-select"
              id="serviceTreeId"
              formControlName="serviceTreeId"
              [items]="serviceTreeOptions"
              bindValue="Oid"
              bindLabel="Name"
              [searchFn]="serviceTreeSearch"
              placeholder="Select Service Tree ID"
              [virtualScroll]="true"
              [clearable]="false"
              [readonly]="!form.get('manatree')?.value"
              notFoundText="No Service Tree IDs are associated with this Manatree"
            >
              <ng-template ng-label-tmp let-item="item">
                <ng-container *ngIf="item.Name; else serviceTreeIdOnly">
                  {{ item.Name }} ({{ item.Oid }})
                </ng-container>
                <ng-template #serviceTreeIdOnly>{{ item.Oid }}</ng-template>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <ng-container *ngIf="item.Name; else serviceTreeOptionIdOnly">
                  {{ item.Name }} ({{ item.Oid }})
                </ng-container>
                <ng-template #serviceTreeOptionIdOnly>{{ item.Oid }}</ng-template>
              </ng-template>
            </ng-select>
            <small
              class="text-danger"
              *ngIf="form.get('serviceTreeId')?.hasError('required') && form.get('serviceTreeId')?.touched"
            >
              Service Tree ID is required
            </small>
          </div>
        </div>

        <div class="form-group row mb-3">
          <label for="region" class="col-sm-3 col-form-label request-label">Region:</label>
          <div class="col-sm-9">
            <ng-select
              class="request-input region-select"
              id="region"
              formControlName="region"
              [items]="regionOptions"
              bindValue="RegionName"
              bindLabel="RegionName"
              placeholder="Select Region"
              [virtualScroll]="true"
              [clearable]="false"
              (change)="onRegionChanged()"
            >
            </ng-select>
            <small
              class="text-danger"
              *ngIf="form.get('region')?.hasError('required') && form.get('region')?.touched"
            >
              Region is required
            </small>
          </div>
        </div>

        <div class="form-group row mb-3">
          <label for="purpose" class="col-sm-3 col-form-label request-label">
            Purpose:
            <i
              class="fa fa-info-circle"
              [ngbTooltip]="purposeTooltip"
              placement="top"
              container="body"
              tabindex="0"
              [attr.aria-label]="purposeTooltip"
            ></i>
          </label>
          <div class="col-sm-9">
            <ng-select
              class="request-input"
              id="purpose"
              formControlName="purpose"
              [items]="purposeOptions"
              placeholder="Select Purpose"
              [clearable]="false"
            >
            </ng-select>
            <small
              class="text-danger"
              *ngIf="form.get('purpose')?.hasError('required') && form.get('purpose')?.touched"
            >
              Purpose is required
            </small>
          </div>
        </div>
      </fieldset>

      <fieldset class="fieldsetstyle mb-4">
        <h5>Sub Requests</h5>
        <hr />

        <div [formGroup]="subRequestForm">
          <div class="form-group row mb-3">
            <label class="col-sm-3 col-form-label request-label">Zone:</label>
            <div class="col-sm-9">
              <div class="subrequest-option-controls request-input">
                <div class="subrequest-option-modes">
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="zoneModeAny"
                      formControlName="ZoneMode"
                      value="Any"
                      (change)="onSubRequestOptionModeChanged('ZoneMode', 'Zone')"
                    />
                    <label class="form-check-label" for="zoneModeAny">Any</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="zoneModeSpecific"
                      formControlName="ZoneMode"
                      value="Specific"
                      (change)="onSubRequestOptionModeChanged('ZoneMode', 'Zone')"
                      (blur)="onSpecificOptionBlur('ZoneMode', 'Zone')"
                    />
                    <label class="form-check-label" for="zoneModeSpecific">Specific</label>
                  </div>
                </div>
                <div class="subrequest-option-input" *ngIf="subRequestForm.get('ZoneMode')?.value === 'Specific'">
                  <ng-select
                    class="request-input"
                    id="subRequestZone"
                    formControlName="Zone"
                    [items]="zoneOptions"
                    bindValue="value"
                    bindLabel="label"
                    placeholder="Select Zone"
                    [clearable]="false"
                  >
                  </ng-select>
                  <small
                    class="text-danger"
                    *ngIf="subRequestForm.get('Zone')?.hasError('required') && subRequestForm.get('Zone')?.touched"
                  >
                    Zone is required
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label class="col-sm-3 col-form-label request-label">Cluster:</label>
            <div class="col-sm-9">
              <div class="subrequest-option-controls request-input">
                <div class="subrequest-option-modes">
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="clusterModeAny"
                      formControlName="ClusterMode"
                      value="Any"
                      (change)="onSubRequestOptionModeChanged('ClusterMode', 'Cluster')"
                    />
                    <label class="form-check-label" for="clusterModeAny">Any</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="clusterModeSpecific"
                      formControlName="ClusterMode"
                      value="Specific"
                      (change)="onSubRequestOptionModeChanged('ClusterMode', 'Cluster')"
                      (blur)="onSpecificOptionBlur('ClusterMode', 'Cluster')"
                    />
                    <label class="form-check-label" for="clusterModeSpecific">Specific</label>
                  </div>
                </div>
                <div class="subrequest-option-input" *ngIf="subRequestForm.get('ClusterMode')?.value === 'Specific'">
                  <input
                    type="text"
                    class="form-control request-input"
                    id="subRequestCluster"
                    formControlName="Cluster"
                    placeholder="Enter Cluster"
                  />
                  <small
                    class="text-danger"
                    *ngIf="subRequestForm.get('Cluster')?.hasError('required') && subRequestForm.get('Cluster')?.touched"
                  >
                    Cluster is required
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label class="col-sm-3 col-form-label request-label">SKU:</label>
            <div class="col-sm-9">
              <div class="subrequest-option-controls request-input">
                <div class="subrequest-option-modes">
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="skuModeAny"
                      formControlName="SkuMode"
                      value="Any"
                      (change)="onSubRequestOptionModeChanged('SkuMode', 'SKU')"
                    />
                    <label class="form-check-label" for="skuModeAny">Any</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="skuModeSpecific"
                      formControlName="SkuMode"
                      value="Specific"
                      (change)="onSubRequestOptionModeChanged('SkuMode', 'SKU')"
                      (blur)="onSpecificOptionBlur('SkuMode', 'SKU')"
                    />
                    <label class="form-check-label" for="skuModeSpecific">Specific</label>
                  </div>
                </div>
                <div class="subrequest-option-input" *ngIf="subRequestForm.get('SkuMode')?.value === 'Specific'">
                  <input
                    type="text"
                    class="form-control request-input"
                    id="subRequestSku"
                    formControlName="SKU"
                    placeholder="Enter SKU"
                  />
                  <small
                    class="text-danger"
                    *ngIf="subRequestForm.get('SKU')?.hasError('required') && subRequestForm.get('SKU')?.touched"
                  >
                    SKU is required
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label for="subRequestQuantity" class="col-sm-3 col-form-label request-label">Quantity:</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control request-input"
                id="subRequestQuantity"
                formControlName="Quantity"
                placeholder="Enter Quantity"
                min="1"
              />
              <small
                class="text-danger"
                *ngIf="subRequestForm.get('Quantity')?.hasError('required') && subRequestForm.get('Quantity')?.touched"
              >
                Quantity is required
              </small>
              <small
                class="text-danger"
                *ngIf="subRequestForm.get('Quantity')?.hasError('min') && subRequestForm.get('Quantity')?.touched"
              >
                Quantity must be at least 1
              </small>
            </div>
          </div>
        </div>

        <div class="form-group row mb-3 subrequest-add-row">
          <div class="col-sm-3"></div>
          <div class="col-sm-9">
            <button type="button" class="btn btn-primary btn-sm" (click)="addSubRequest()">Add Row</button>
            <small class="text-danger d-block" *ngIf="showNoSubRequestError">
              At least one subrequest is required
            </small>
          </div>
        </div>

        <div class="subrequest-table-shell">
          <p class="text-muted small mb-2">
            Enter the subrequest details and select <strong>Add Row</strong>. Select a table row, then click <strong>Remove Row</strong> to remove it.
          </p>
          <ag-grid-angular
            class="ag-theme-balham"
            style="width: 100%"
            domLayout="autoHeight"
            [columnDefs]="subRequestColumnDefs"
            [defaultColDef]="subRequestDefaultColDef"
            [rowData]="subRequests"
            rowSelection="single"
            [overlayNoRowsTemplate]="'No subrequests have been added.'"
            (gridReady)="onSubRequestGridReady($event)"
            (selectionChanged)="onSubRequestSelectionChanged($event)"
            (firstDataRendered)="$event.api.sizeColumnsToFit()"
          >
          </ag-grid-angular>
          <div class="d-flex justify-content-end mt-2">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              [disabled]="!hasSelectedSubRequest"
              (click)="removeSelectedSubRequest()"
            >
              Remove Row
            </button>
          </div>
        </div>
      </fieldset>

      <div class="d-flex justify-content-end mb-4">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading">
          <span *ngIf="!isLoading">Create</span>
          <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Creating...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
